import { ServiceType } from "../../../Models/ServiceType";
import Service from "../../../Models/Service";
import Item from "../../../Models/Item";
import OrderHandler from "../OrderHandler";
import { createImg } from "../../../DomUtilities/ElementsCreator";
import Mediator from "../../../Utilities/Mediator";
import { isNumber, isValidQuantity } from "../../../Validations/Validations";

export default class ItemRow {
	cost: number = 0;
	item: Item;
	row: HTMLDivElement;
	priceText: Text;

	constructor(item: Item) {
		this.item = item;
		this.cost = 0;
		this.row = document.createElement('div');
	}

	public createRow(): HTMLDivElement {
		this.row.classList.add('t-row');
		this.createItemServicesTotal();
		this.createQuantityInput();
		this.createPrice();

		return this.row;
	}

	private createItemServicesTotal() {
		const itemServiceDiv = document.createElement('div');
		const pItem = document.createElement('p');
		const serviceList = document.createElement('ul');

		itemServiceDiv.classList.add('item-service');
		pItem.innerText = this.item.name;

		this.item.services.forEach(service => {
			const serviceListItem = document.createElement('li');
			serviceListItem.innerText = this.getVariantDetails(service);
			serviceList.appendChild(serviceListItem);
		});

		itemServiceDiv.appendChild(pItem);
		itemServiceDiv.appendChild(serviceList);

		this.row.append(itemServiceDiv);
	}

	private getVariantDetails(service: Service): string {
		switch (service.type) {
			case ServiceType.Canvas:
				let variantName: string = "";
				service.variants.forEach(variant => {
					variantName += `- ${variant.name}, kanvas `;
					this.cost += variant.cost;
				});
				return variantName;
			case ServiceType.Measurements:
				this.cost += service.variants[0].cost;
				if (service.variants[0].byNeedle) {

					return `${service.variants[0].name}, nål`;
				} else {
					let cm: string;
					if (service.variants[0].cmDown) {
						cm = `+${service.variants[0].cmDown}`;
					} else {
						cm = `-${service.variants[0].cmUp}`;
					}

					return `${service.variants[0].name}, (${cm} cm)`;
				}
			default:
				this.cost += service.variants[0].cost;

				return `${service.variants[0].name}`;
		}
	}

	private createQuantityInput() {
		const qty = document.createElement('div');
		const input = document.createElement('input');
		const arrowsDiv = this.createInputNumberArrows(input);
		this.addQuantityInputListener(input);

		qty.classList.add('qty');
		input.type = 'number';
		input.min = '1';
		input.max = "99";
		input.step = '1';
		input.minLength = 1;
		input.classList.add('form-control');
		input.value = this.item.count.toString();

		qty.appendChild(input);
		qty.appendChild(arrowsDiv);
		this.row.append(qty);
	}

	private addQuantityInputListener(input: HTMLInputElement) {
		input.oninput = (event: InputEvent) => {
			const inputKey = event.data;
			const isValidInput = isNumber(inputKey) && isValidQuantity(input.value, 1, 99);
			if (!isValidInput) {
				input.value = input.value.replace(inputKey, '');
				if (!input.value) {
					input.value = "1";
				}
			}
			this.updateCount(input);
		}
	}

	private createInputNumberArrows(input: HTMLInputElement): HTMLDivElement {
		const arrowsDiv = document.createElement("div");
		const imgIncrease = createImg("/assets/chevron_right.svg", "increase icon");
		const br = document.createElement('br');
		const imgDecrease = createImg("/assets/chevron_right.svg", "decrease icon");

		arrowsDiv.classList.add("input-number");
		this.addArrowsClickListener(input, imgIncrease, imgDecrease);

		arrowsDiv.appendChild(imgIncrease);
		arrowsDiv.appendChild(br);
		arrowsDiv.appendChild(imgDecrease);

		return arrowsDiv;
	}

	private addArrowsClickListener(input: HTMLInputElement, imgIncrease: HTMLImageElement,
		imgDecrease: HTMLImageElement) {
		imgIncrease.onclick = () => {
			let value = parseInt(input.value);
			value++;
			input.value = value.toString();
			this.updateCount(input);
		}

		imgDecrease.onclick = () => {
			let value = parseInt(input.value);
			if (value > 1) {
				value--;
				input.value = value.toString();
				this.updateCount(input);
			}
		}
	}

	private updateCount(input: HTMLInputElement) {
		let count = parseInt(input.value);
		let oldCost = this.item.count * this.cost;
		Mediator.emit(`itemCountChanged`, count, this.cost, oldCost);
		this.item.count = count;
		this.changeItemRowPrice();
	}

	private createPrice() {
		const price = document.createElement('div');
		const p = document.createElement('p');
		const img = createImg('/assets/close.svg', 'remove icon');
		this.priceText = document.createTextNode("");

		img.onclick = () => {
			this.removeItemFromShoppingCart();
		}

		price.classList.add('price');
		this.changeItemRowPrice();

		p.append(this.priceText);
		p.append(img);
		price.append(p);

		this.row.append(price);
	}

	private changeItemRowPrice() {
		this.priceText.data = `${this.cost * this.item.count} DKK`;
	}

	private removeItemFromShoppingCart() {
		OrderHandler.removeItem(this.item.itemId);
		let oldCost = this.item.count * this.cost;
		this.item.count = 0;
		Mediator.emit(`itemCountChanged`, this.item.count, this.cost, oldCost);
		this.row.remove();
	}
}
